import { RemoveRedEye } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { LightTooltip } from 'lib/designSystem/WhiteTooltip';
import React from 'react';

import EnhancedTable from '../../../../../../../lib/designSystem/Table';

interface Collection {
  id: number;
  type: string;
  state: string;
  createdAt: string;
  completedAt: string | null;
  dueDate: string | null;
  description: string | null;
}

const CollectionsComponent = (collections: Collection[]) => {
  if (!collections || collections.length === 0) return null;

  const formatDate = (dateString: string | null) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('es-CL', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  };

  const tableData = collections.map((collection) => ({
    id: collection.id,
    type: collection.type,
    state: collection.state,
    createdAt: formatDate(collection.createdAt),
    completedAt: formatDate(collection.completedAt),
    dueDate: formatDate(collection.dueDate),
    description: collection.description || '-',
  }));

  const customTitle = (
    <div style={{ padding: '15px', minWidth: '800px' }}>
      <Typography
        variant="body1"
        color="textPrimary"
        style={{ marginBottom: '10px', fontWeight: 'bold' }}
      >
        Historial de Cobranzas
      </Typography>
      <EnhancedTable
        dataHeaders={[
          { key: 'type', label: 'Tipo' },
          { key: 'state', label: 'Estado' },
          { key: 'dueDate', label: 'Fecha programada' },
          { key: 'description', label: 'Descripción' },
        ]}
        data={tableData}
        rowsPerPageDefault={5}
        tableSize="small"
      />
    </div>
  );

  return (
    <LightTooltip title={customTitle} placement="right">
      <RemoveRedEye />
    </LightTooltip>
  );
};

export default CollectionsComponent;
